import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputNumberDirective } from '@shared/components/input/number/input-number.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { ConnectionRightForm, getDanishDate } from '@shared/forms/connection-right.formgroup';
import { AlertComponent } from '@shared/components/alert/alert.component';

@Component({
  selector: 'app-connection-right-form',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputDateDirective,
    InputDirective,
    InputNumberDirective,
    InputGroupComponent,
    LabelDirective,
    AlertComponent,
  ],
  templateUrl: './connection-right-form.component.html',
})
export class ConnectionRightFormComponent {
  @Input({ required: true }) public form!: FormGroup<ConnectionRightForm>;
  @Input() public showTitle = true;
  @Input() public isExpired = false;
  public readonly maximumValidFrom = getDanishDate();
}
